/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'seg-update-gird-container';
const prefix = `${moduleName}.${componentName}`;

export const haModeLabel = `${prefix}.haModeLabel`;
export const patchLabel = `${prefix}.patchLabel`;
export const updatedOnLabel = `${prefix}.updatedOnLabel`;

export const ENGLISH = {
    [haModeLabel]: 'HA Mode',
    [patchLabel]: 'Patch',
    [updatedOnLabel]: 'Updated on',
};
